import React from 'react'
import "./YoutubeGalleryPage.css"

export const YoutubeGalleryPage = () => {
    return (
        <div>
             <ul className="YoutubeListContainer">
             	<li>
             		<iframe width="560" title="yt-1" height="315" src="https://www.youtube.com/embed/uOEUcVyhTWU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
             	</li>
             	<li>
             	<iframe width="560" title="yt-2" height="315" src="https://www.youtube.com/embed/-kIJFZUCmsg" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
             	</li>
             	<li>
             		<iframe width="560" title="yt-3" height="315" src="https://www.youtube.com/embed/HA4Chc1hb3M" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
             	</li>
             	<li>
             		<iframe width="560" title="yt-4" height="315" src="https://www.youtube.com/embed/mFj3-qR1Aeg" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
             	</li>
             	<li>
             		<iframe width="560" title="yt-5" height="315" src="https://www.youtube.com/embed/KoEJ0YdZcoA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;
picture - in -picture" allowfullscreen></iframe>
             	</li>
             </ul>
        </div>
    )
}